// extracted by mini-css-extract-plugin
export default {"itemLeft":"GuidelineItem_itemLeft__zIkni","itemRight":"GuidelineItem_itemRight__gHpBF"};